<label
  class="checkbox"
  [ngClass]="{ 'checkbox--checked': fc.value }"
  [title]="title"
>
  <span class="checkbox__checkmark-container">
    <input type="checkbox" [formControl]="fc" class="d-none" />

    <span class="checkbox__checkmark"></span>
  </span>

  <span class="text-small semi-bold">{{
    fc.value
      ? ("follow-checkbox-following" | t)
      : ("follow-checkbox-follow" | t)
  }}</span>
</label>
